<template>
  <div>
    <div class="columns">
      <div v-if="childCategories.length > 0" class="column">
        <div class="title is-4">Разделы</div>
        <div>
          <p class="field">
            <template v-for="item in childCategories">
              <span
                @click="handleFilter('categories', item.id)"
                :class="cssClass('categories', item.id)">{{item.name}}
              </span>
            </template>
          </p>
        </div>
      </div>

      <div v-if="models.length > 0" class="column">
        <div class="title is-4">Модели</div>
        <div>
          <p class="field">
            <template v-for="item in models">
              <span
                @click="handleFilter('models', item.id)"
                :class="cssClass('models', item.id)">{{item.name}}
              </span>
            </template>
          </p>
        </div>
      </div>
    </div>

    <div class="columns">
      <div v-if="tags.length > 0" class="column">
        <div class="title is-4">Популярное</div>
        <div>
          <p class="field">
            <template v-for="item in tags">
              <span
                @click="handleFilter('tags', item.id)"
                :class="cssClass('tags', item.id)">{{item.name}}
              </span>
            </template>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import _ from 'lodash'

  /**
   * Фильтр товаров.
   */
  export default {
    name: 'product-filter',

    props: {
      /**
       * Выбранное значение в фильтре.
       */
      value: {
        type: Object,
        required: true
      },

      childCategories: {
        type: Array,
        required: true
      },

      models: {
        type: Array,
        required: true
      },

      tags: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        innerValue: _.cloneDeep(this.value)
      }
    },

    methods: {
      handleFilter (section, id) {
        if (this.isSelected(section, id)) {
          this.innerValue[section] = _.without(this.innerValue[section], id)
        } else {
          this.innerValue[section].push(id)
        }

        this.$emit('input', this.innerValue)
      },

      cssClass (section, id) {
        return [
          {'is-primary': this.isSelected(section, id)},
          'tag', 'is-medium', 'gl-tag'
        ]
      },

      isSelected (section, id) {
        return this.innerValue[section].includes(id)
      }
    }
  }
</script>


<style scoped lang="scss">
  .gl-tag {
    cursor: pointer;
    margin: 0 .3rem .3rem 0;

    &.not-available {
      background: #CCC;
      opacity: .5;
      cursor: not-allowed;
    }
  }
</style>



// WEBPACK FOOTER //
// Filter.vue?ba1a6708